export default {
  animation: 200,
  forceFallback: true,
  fallbackClass: 'is-dragging',
  fallbackOnBody: true,
  ghostClass: 'is-ghost',
};



// WEBPACK FOOTER //
// ./sortable/sortable_config.js